import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-loader/dist/index.module.css';
import ProgressiveIndicator from '@dtsl/icons/dist/icons/react/ProgressiveIndicator';
function Loader(props) {
  const {
    indicator,
    className,
    isAbsolute
  } = props;
  const loaderClass = classNames({
    [styles['sib-loader']]: true,
    [styles['sib-loader--absolute']]: isAbsolute,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("span", {
    className: loaderClass
  }, indicator);
}
Loader.propTypes = {
  indicator: PropTypes.node,
  className: PropTypes.string,
  isAbsolute: PropTypes.bool
};
Loader.defaultProps = {
  indicator: /*#__PURE__*/React.createElement(ProgressiveIndicator, {
    width: "24",
    height: "24"
  }),
  isAbsolute: true,
  className: ''
};
export default Loader;